import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import logo from '../img/logo.png';
import { Helmet } from 'react-helmet';
import axios from 'axios';
import { FaAddressBook, FaDollarSign, FaDownload, FaFilePdf, FaCalendar, FaGifts, FaHeart, FaImage, FaMoneyBillWave, FaMusic, FaPalette, FaSpinner, FaWhatsapp } from 'react-icons/fa';
import Recommended from '../components/Recommended';
import NavBar from '../components/NavBar';
import FeaturesModal from '../components/FeaturesModal';


import translations from '../translations';

const Manage = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [event, setEvent] = useState('');
  const [walimatulurus, setWalimatulurus] = useState('');
  const [status, setStatus] = useState('');
  const [groomName, setGroomName] = useState('');
  const [brideName, setBrideName] = useState('');
  const [message, setMessage] = useState('');
  const [weddingDate, setWeddingDate] = useState('');
  const [parentName, setParentName] = useState('');
  const [location, setLocation] = useState('');
  const [createdAt, setCreatedAt] = useState('');
  const [timeLeft, setTimeLeft] = useState({ hours: 0, minutes: 0, seconds: 0 });
  const [expired, setExpired] = useState(false);
  const [showNotification, setShowNotification] = useState(false);

  const [temaStatus, setTemaStatus] = useState(0);
  const [musicStatus, setMusicStatus] = useState(0);
  const [rsvpStatus, setRsvpStatus] = useState(0);
  const [moneyGiftStatus, setMoneyGiftStatus] = useState(0);
  const [galleries, setGalleries] = useState(0);
  const [pdfStatus, setPdfStatus] = useState(0);
  const [wishlistStatus, setWishlistStatus] = useState(0);
  const [downloadStatus, setDownloadStatus] = useState(0);
  const [plannerStatus, setPlannerStatus] = useState(0);
  const [pakej, setPakej] = useState(0);

  const email = localStorage.getItem('userEmail');
  const token = localStorage.getItem('token');

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [language, setLanguage] = useState(localStorage.getItem('language') || 'en');
  const t = translations[language];

  const features = async (pakej) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/features/${pakej}`);
      const data = response.data;

      setTemaStatus(data.designs);
      setMusicStatus(data.music);
      setRsvpStatus(data.rsvp);
      setMoneyGiftStatus(data.money_gift);
      setGalleries(data.galleries);
      setPdfStatus(data.pdf);
      setWishlistStatus(data.wishlist);
      setDownloadStatus(data.download);
      setPlannerStatus(data.planner);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/kad/${id}`);
        const data = response.data;

        setWalimatulurus(data.walimatulurus);
        setStatus(data.status);
        setGroomName(data.groom_name);
        setBrideName(data.bride_name);
        setWeddingDate(data.wedding_date);
        setParentName(data.parent_name);
        setMessage(data.message);
        setLocation(data.location);
        setCreatedAt(data.created_at);
        setPakej(data.pakej);
        features(data.pakej);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [id]); 

  useEffect(() => {
    const getEvent = async () => {
      axios.get(`${process.env.REACT_APP_API_BASE_URL}/clients/${id}`)
        .then(response => {
          const event = response.data.event;
          setEvent(event);
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    };

    getEvent();

  }, [id]);

  useEffect(() => {
    // Function to calculate the time difference
    const calculateTimeLeft = () => {
      const expirationTime = new Date(createdAt).getTime() + 1 * 60 * 60 * 1000;
      const currentTime = new Date().getTime();
      const difference = expirationTime - currentTime;

      if (difference > 0) {
        const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((difference / (1000 * 60)) % 60);
        const seconds = Math.floor((difference / 1000) % 60);
        setTimeLeft({ hours, minutes, seconds });
      } else {
        // If the expiration time has passed
        setTimeLeft({ hours: 0, minutes: 0, seconds: 0 });
        setExpired(true);
      }
    };

    // Update the countdown every second
    const interval = setInterval(calculateTimeLeft, 1000);

    // Cleanup the interval on component unmount
    return () => clearInterval(interval);
  }, [createdAt]);

  const weddingDateSet = new Date(weddingDate);
  const weddingDay = getDayFromDate(weddingDateSet);

  // Check if wedding date has passed more than 1 day
  const isEditDisabled = () => {
    const today = new Date();
    const oneDayAfterWedding = new Date(weddingDateSet);
    oneDayAfterWedding.setDate(oneDayAfterWedding.getDate() + 1);
    return today > oneDayAfterWedding;
  };

  const formattedDate = weddingDateSet.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  // Function to calculate the day from a given date
  function getDayFromDate(date) {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const dayIndex = date.getDay();
    localStorage.setItem('Day', days[dayIndex]);
    return days[dayIndex];
  }
  
  const url = `${process.env.REACT_APP_KAD_BASE_URL}/${id}`;
  const edit = `/edit/${id}`;
  const rsvp = `/rsvp/${id}`;
  const music = `/music/${id}`;
  const aktifkan = `/select-plan/${id}`;
  const tema = `/designs/${id}`;
  const gallery = `/gallery/${id}`;
  const pdf = `/pdf/${id}`;
  const wishlist = `/wishlist/${id}`;
  const moneyGift = `/moneygift/${id}`;
  const download = `/download/${id}`;
  const planner = email && token
    ? `${process.env.REACT_APP_PLANNER_URL}/id/${id}/${email}/${token}`
    : `${process.env.REACT_APP_PLANNER_URL}/id/${id}`;

  const shareText = `
❤️ ${walimatulurus} ❤️

${groomName} & ${brideName}
      
${url}
          
🗓️ ${weddingDay}, ${formattedDate}
📍 ${location}

Don't forget to RSVP

#${event}
  `;

  const handleCopy = () => {
    const textarea = document.getElementById('invitationText');
    textarea.select();
    document.execCommand('copy');
    alert(t.textCopied);
  };

  const handleHashtag = () => {
    axios.put(`${process.env.REACT_APP_API_BASE_URL}/update-hashtag/${id}`, { event: event })
      .then(response => {
          console.log(response.data.message); // Log success message
          alert(t.hashtagUpdated);
          window.location.reload();
      })
      .catch(error => {
          console.error('Error updating hashtag:', error);
      });
  };

  const handleDisabledEditClick = () => {
    setShowNotification(true);
    setTimeout(() => setShowNotification(false), 3000); // Hide after 3 seconds
  };

  const [phoneNumber, setPhoneNumber] = useState(false);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/settings`)
      .then(response => setPhoneNumber(response.data.whatsapp_no))
      .catch(error => console.error('Error fetching settings:', error));
  }, []);

  const handleClick = (e) => {
    e.preventDefault(); // Prevent navigation
    setIsModalOpen(true); // Open modal
  };

  return (
    <div className="relative">
      <Helmet>
        <title>{t.dashboardTitle} | {process.env.REACT_APP_SITE_NAME}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      
      {loading ? ( 
          <div className="fixed inset-0 flex flex-col items-center justify-center space-y-5">
            <FaSpinner className="text-4xl text-black animate-spin" />
            <img src={logo} alt="Logo" className="h-10 mb-4" />
          </div>
        ) : (
          <div>
            {showNotification && (
              <div className="fixed top-1/4 left-1/2 transform -translate-x-1/2 bg-red-100 border border-red-400 text-red-700 px-6 py-3 rounded-lg shadow-lg z-50 animate-fade-in">
                <p className="text-center">{t.cannotEditAfterEvent}</p>
              </div>
            )}
            <NavBar />
            <div className="bg-gray-50 flex pt-20 justify-center min-h-screen">
              <div className=" px-8 py-8 max-w-md w-full">

                {status === 'unverified' ?(
                  <div className='flex items-center justify-between pb-2'>
                    <div>
                      {expired ? (
                        <p>{t.status}: <span className='font-bold text-secondary-700'>{t.expired}</span></p> // Display "Expired" when the time is up
                      ) : (
                        <>
                          <p>{t.status}: <span className='font-bold'>{t.trial}</span></p>
                          <p className='text-sm'>{t.trialEndsIn}: {timeLeft.hours}h: {timeLeft.minutes}m: {timeLeft.seconds}s</p>
                        </>
                      )}
                    </div>
                    <div className='space-x-2'>
                      <Link
                        to={url}
                        className='btn-secondary'>
                          {t.view}
                      </Link>
                      <Link
                        to={aktifkan}
                        className='px-3 py-2 rounded-lg bg-primary hover:bg-secondary text-highlight'>
                          {t.activate}
                      </Link>
                    </div>
                  </div>
                ):(
                  <div className='flex items-center justify-between pb-2'>
                    <p>{t.status}: <span className='font-bold text-green-500'>{t.active}</span></p>
                    <Link
                      to={url}
                      className='btn-secondary'>
                        {t.view}
                    </Link>
                  </div>
                )}
                
                <p className='text-sm pb-4'>{t.plan}: <span className='font-bold text-accent uppercase'>{pakej}</span></p>


                <div className='relative px-5 py-2 rounded-lg shadow-xl mb-8 bg-white'>
                  {/* Icons in the background */}
                  <div className="absolute inset-0 flex justify-center items-center opacity-30">
                    {/* Adjust the number of icons and their size as needed */}
                    <FaHeart className="text-red-300 text-6xl mx-2" />
                    <FaHeart className="text-red-300 text-6xl mx-2" />
                    <FaHeart className="text-red-300 text-6xl mx-2" />
                  </div>
  
                  {/* Content */}
                  <div className='relative py-8'>
                    <p className='capitalize'>{walimatulurus}</p>
                    <h2 className='text-2xl font-bold'>{groomName} & {brideName}</h2>
                    <p>{weddingDay}, {formattedDate}</p>
                  </div>
                </div>
                <div className='text-center'>
                  <div className='mb-4'>
                    <div className='flex items-center'>
                      <label className='text-lg p-2'>#</label>
                      <input
                        type="text"
                        value={event}
                        onChange={(e) => {
                          const value = e.target.value.replace(/[^a-zA-Z0-9]/g, ''); // Remove spaces and symbols
                          setEvent(value); // Set the cleaned value
                        }}
                        className="border px-5 py-3 mb-2 w-full"
                        placeholder={t.enterHashtag}
                        required
                      />
                    </div>
                    <button
                      onClick={handleHashtag}
                      className="btn-primary px-3 py-2 rounded w-full"
                    >
                      {t.updateHashtag}
                    </button>
                  </div>
                  <textarea 
                    id="invitationText"
                    value={shareText}
                    readOnly
                    rows="10"
                    className="w-full p-2 border rounded"
                  />
                  <button
                    onClick={handleCopy}
                    className="btn-primary px-3 py-2 rounded w-full"
                  >
                    {t.copyShare}
                  </button>
                  <div className='flex items-center justify-between space-x-2 mt-2'>
                    <Link
                      to={url}
                      className="btn-tertiary text-center px-3 py-2 rounded w-full"
                    >
                      {t.view}
                    </Link>
                    {isEditDisabled() ? (
                      <button
                        type="button"
                        onClick={handleDisabledEditClick}
                        className="btn-secondary text-center px-3 py-2 rounded w-full opacity-50 cursor-not-allowed"
                        title={t.editingDisabled}
                      >
                        {t.edit}
                      </button>
                    ) : (
                      <Link
                        to={edit}
                        className="btn-secondary text-center px-3 py-2 rounded w-full"
                      >
                        {t.edit}
                      </Link>
                    )}
                  </div>
                  <FeaturesModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
                  <div className='my-6'>
                    <div className='grid grid-cols-3 gap-4'>
                      <Link
                        to={rsvpStatus ? rsvp : "#"}
                        onClick={rsvpStatus ? null : handleClick}
                        className="btn-primary p-3 rounded-lg border border-primary flex flex-col items-center space-y-2"
                      >
                        <FaAddressBook className="text-3xl" />
                        <p className="text-xs">{t.rsvp}</p>
                      </Link>
                      <Link
                        to={musicStatus ? music : "#"}
                        onClick={musicStatus ? null : handleClick}
                        className="btn-primary p-3 rounded-lg border border-primary flex flex-col items-center space-y-2"
                      >
                        <FaMusic className="text-3xl" />
                        <p className="text-xs">{t.music}</p>
                      </Link>
                      <Link
                        to={temaStatus ? tema : "#"}
                        onClick={temaStatus ? null : handleClick}
                        className="btn-primary p-3 rounded-lg border border-primary flex flex-col items-center space-y-2"
                      >
                        <FaPalette className="text-3xl" />
                        <p className="text-xs">{t.designs}</p>
                      </Link>
                      <Link
                        to={galleries ? gallery : "#"}
                        onClick={galleries ? null : handleClick}
                        className="btn-primary p-3 rounded-lg border border-primary flex flex-col items-center space-y-2"
                      >
                        <FaImage className="text-3xl" />
                        <p className="text-xs">{t.gallery}</p>
                      </Link>
                      <Link
                        to={pdfStatus ? pdf : "#"}
                        onClick={pdfStatus ? null : handleClick}
                        className="btn-primary p-3 rounded-lg border border-primary flex flex-col items-center space-y-2"
                      >
                        <FaFilePdf className="text-3xl" />
                        <p className="text-xs">{t.saveAsPdf}</p>
                      </Link>
                      <Link
                        to={wishlistStatus ? wishlist : "#"}
                        onClick={wishlistStatus ? null : handleClick}
                        className="btn-primary p-3 rounded-lg border border-primary flex flex-col items-center space-y-2"
                      >
                        <FaGifts className="text-3xl" />
                        <p className="text-xs">{t.wishlist}</p>
                      </Link>
                      <Link
                        to={moneyGiftStatus ? moneyGift : "#"}
                        onClick={moneyGiftStatus ? null : handleClick}
                        className="btn-primary p-3 rounded-lg border border-primary flex flex-col items-center space.y-2"
                      >
                        <FaDollarSign className="text-3xl" />
                        <p className="text-xs">{t.moneyGift}</p>
                      </Link>
                      <Link
                        to={downloadStatus ? download : "#"}
                        onClick={downloadStatus ? null : handleClick}
                        className="btn-primary p-3 rounded-lg border border-primary flex flex-col items-center space-y-2"
                      >
                        <FaDownload className="text-3xl" />
                        <p className="text-xs">{t.downloadInvitation}</p>
                      </Link>
                      <Link
                        to={plannerStatus ? planner : "#"}
                        onClick={plannerStatus ? null : handleClick}
                        className="btn-primary p-3 rounded-lg border border-primary flex flex-col items-center space-y-2"
                      >
                        <FaCalendar className="text-3xl" />
                        <p className="text-xs">{t.weddingPlanner}</p>
                      </Link>
                    </div>
                  </div>
                </div> 
              </div>
            </div>
          </div>
        )
      }
    </div>
    
  );
};

const styles = document.createElement('style');
styles.textContent = `
  @keyframes fadeIn {
    from { opacity: 0; transform: translate(-50%, -20px); }
    to { opacity: 1; transform: translate(-50%, 0); }
  }
  .animate-fade-in {
    animation: fadeIn 0.3s ease-out forwards;
  }
`;
document.head.appendChild(styles);

export default Manage;
